import type React from 'react';

type ChatEnterButtonProps = {
  submit: () => void;
  color: string;
};

const ChatEnterButton: React.FC<ChatEnterButtonProps> = ({ submit, color }) => (
  <button type='submit' className='enter-button' onClick={() => submit()}>
    <i className='fas fa-paper-plane' style={{ color }} />
  </button>
);

export default ChatEnterButton;
